import TrustpilotSlider from "./TrustpilotSlider";

export { TrustpilotSlider };
